
export class CommonRequestAttrs {
    
    username: string;

    constructor(username: string) {
        this.username = username;
    }
}